import Hypercasuals from 'projects/Hypercasuals';
import MidnightDraw from 'projects/MidnightDraw';
import MMAFederation from 'projects/MMAFederation';
import YatzyParty from 'projects/YatzyParty';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Bio from '../components/Bio';
import Dominos from '../projects/Dominos';
import Dungeonland from '../projects/Dungeonland';
import CoverLetter from './CoverLetter';
import './PortfolioView.scss';

const PortfolioView = () => {
    return (
        <Switch>
            <Route path='/dungeonland'>
                <Dungeonland />
            </Route>
            <Route path='/midnight-draw'>
                <MidnightDraw />
            </Route>
            <Route path='/hypercasuals'>
                <Hypercasuals />
            </Route>
            <Route path='/yatzy-party'>
                <YatzyParty />
            </Route>
            <Route path='/dominos'>
                <Dominos />
            </Route>
            <Route path='/mma-federation'>
                <MMAFederation />
            </Route>
            <Route path='/ustwo'>
                <CoverLetter />
            </Route>
            <Route path='/'>
                <Bio />
            </Route>
        </Switch>
    );
};

export default PortfolioView;
